// eslint-disable-next-line @typescript-eslint/no-var-requires
export const APPLICATION_VERSION = require("../../package.json").version;